import { render, staticRenderFns } from "./trev-editor.vue?vue&type=template&id=7b25e9e0&scoped=true&"
import script from "./trev-editor.vue?vue&type=script&lang=js&"
export * from "./trev-editor.vue?vue&type=script&lang=js&"
import style0 from "./trev-editor.vue?vue&type=style&index=0&id=7b25e9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b25e9e0",
  null
  
)

export default component.exports